import React from 'react';
import { Typography, Icon } from '@mui/material';
import {
  StyledDialog,
  StyledDialogTitle,
  StyledDialogContent,
  StyledDialogActions,
  PrimaryButton,
  CloseButton
} from '../shared/modalStyles';

export interface PhoneNumberInUseModalProps {
  onDismiss: () => void;
  phoneNumber?: string;
}

export const PhoneNumberInUseModal: React.FC<PhoneNumberInUseModalProps> = ({
  onDismiss,
  phoneNumber
}) => {
  return (
    <StyledDialog
      open={true}
      onClose={onDismiss}
      aria-labelledby="phone-number-in-use-dialog-title"
      aria-describedby="phone-number-in-use-dialog-description"
    >
      <StyledDialogTitle id="phone-number-in-use-dialog-title">
        Número de WhatsApp en uso
        <CloseButton
          onClick={onDismiss}
          aria-label="Close modal"
        >
          <Icon className="icon icon-close" sx={{ fontSize: '12px' }} />
        </CloseButton>
      </StyledDialogTitle>
      <StyledDialogContent>
        <Typography
          id="phone-number-in-use-dialog-description"
          fontSize="14px"
        >
          El número de teléfono {phoneNumber ? `(${phoneNumber})` : ''} ya está siendo utilizado.
          Por favor, selecciona un número diferente.
        </Typography>
      </StyledDialogContent>
      <StyledDialogActions>
        <PrimaryButton
          variant="contained"
          onClick={onDismiss}
        >
          Entendido
        </PrimaryButton>
      </StyledDialogActions>
    </StyledDialog>
  );
};